import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import Landing from "./pages/Landing";
import Pricing from "./pages/Pricing";
import Auth from "./pages/Auth";
import ForgotPassword from "./pages/ForgotPassword";
import Wizard from "./pages/Wizard";
import Dashboard from "./pages/Dashboard";
import Settings from "./pages/Settings";
import BillingSuccess from "./pages/BillingSuccess";
import Admin from "./pages/Admin";
import Resources from "./pages/Resources";
import AdminResources from "./pages/AdminResources";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/forgot" element={<ForgotPassword />} />
          <Route path="/wizard" element={<Wizard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/billing/success" element={<BillingSuccess />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/resources" element={<AdminResources />} />
          <Route path="/resources" element={<Resources />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "var(--bg-elev)",
            color: "var(--text)",
            border: "1px solid var(--border)",
            fontFamily: "var(--sans)",
          },
        }}
      />
    </AuthProvider>
  );
}

export default App;
